module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-room-in-box column"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.toBack()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "waiting-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("待機室")]), _vm._v(" "), (_vm.home == 1) ? _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": _vm.deleteRoom
    }
  }, [_vm._v("\n                ルームを削除\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "waiting-info-box column"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("基本情報")]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ルーム名")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.roomName))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ファシリテーター")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.homeownerName))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("開始時刻")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.startTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("テーマ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("手札公開")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.isPublic))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("カードコピー機能")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.isCopy))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人数")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.peopleNumber) + "人")])])]), _vm._v(" "), (_vm.isJoin == false && _vm.home != 1) ? _c('div', [_c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": _vm.doJoin
    }
  }, [_vm._v("参加する")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert"
  }, [_vm._v("プレイ時にカードが正常に表示されないときはブラウザを更新してください。")])]) : _c('div', [(_vm.status == 'waiting') ? _c('div', {
    staticClass: "waiting-des-box column row-center"
  }, [_c('div', [_vm._v("ファシリテーターがプレイヤーを選択中です。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("しばらくお待ちください。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("プレイ時にカードが正常に表示されないときはブラウザを更新してください。")])]) : _c('div', {
    staticClass: "waiting-des-box column row-center"
  }, [_c('div', [_vm._v("このゲームは既に開始されています。")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "change-box",
    attrs: {
      "title": "招待コードを入力してください",
      "top": "250px",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm,
      "rules": _vm.passRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "autocomplete": "off",
      "placeholder": ""
    },
    model: {
      value: (_vm.passForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "password", $$v)
      },
      expression: "passForm.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box row row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSub('passForm')
      }
    }
  }, [_vm._v("続ける")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2558ae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/room/Info.vue
// module id = 899
// module chunks = 1